import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, normalizeClass as _normalizeClass, isRef as _isRef, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["data-application-badge"]
const _hoisted_2 = {
  class: "flex-fill layers d-flex flex-column",
  style: {"min-width":"0"}
}
const _hoisted_3 = { class: "text-truncate" }
const _hoisted_4 = { style: {"font-size":".7em","margin-top":".7em","font-weight":"initial"} }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = { class: "text-truncate pr-2 flex-fill" }
const _hoisted_7 = { class: "flex-fill position-relative h-100" }

import {computed, onBeforeUnmount, onMounted, provide, Ref, ref, watch} from 'vue';
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import OperatorApplicationPlatform from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import OperatorApplicationPlatformFactory from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import {OperatorApplicationMenuItem, OperatorApplicationMenuSection} from "~/operatorApplication/vue/layout/Interface";
import {OperatorApplicationRoutingStore} from "~/operatorApplication/ts/store/OperatorApplicationRoutingStore";
import Events from "~/ts/library/Events";
import Delay from "~/ts/library/Delay";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import {OPERATOR_APPLICATION_NEWS_ROUTE_NAME} from "~/operatorApplication/ts/router/OperatorApplicationRouteNames";
import AutoAfk from "~/operatorApplication/ts/service/status/AutoAfk";
import {addDisposableEvent} from "~/ts/vuePlugins/useDisposableEvent";
import OperatorApplicationMainMenu from "~/operatorApplication/vue/layout/OperatorApplicationMainMenu.vue";
import OperatorApplicationStatusLine from "~/operatorApplication/vue/layout/OperatorApplicationStatusLine.vue";
import OperatorApplicationFreeDialog from "~/operatorApplication/vue/layout/OperatorApplicationFreeDialog.vue";
import OperatorApplicationSection from "~/operatorApplication/vue/layout/OperatorApplicationSection.vue";
import {LightboxInjection} from "~/core-ui/ts/LightboxInjection";
import VueEasyLightbox from "~/core-ui/vue/vue-easy-lightbox/VueEasyLightbox.vue";
import {
    OPERATOR_RELOAD_APP_CONFIG,
    OperatorApplicationEventManager
} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import {__} from "~/ts/library/Translate";
import WebRtcCall from "~/core-ui/vue/chat/webrtc/WebRtcCall.vue";
import OperatorApplicationWebRtcCall from "~/operatorApplication/ts/service/webRtc/OperatorApplicationWebRtcCall";
import NewIncomingWebRtcCall from "~/core-ui/vue/chat/webrtc/NewIncomingWebRtcCall.vue";
import OperatorApplicationDialogForCabinetReports
    from "~/operatorApplication/vue/cabinetIframe/OperatorApplicationDialogForCabinetReports.vue";
import CabinetIframeWrapper from "~/operatorApplication/vue/cabinetIframe/CabinetIframeWrapper.vue";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";


const __default__ = {
    name: "OperatorApplicationLayout"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


let lightboxSrc = ref<string>();

provide(LightboxInjection, src => lightboxSrc.value = src);

let visitedSections = ref<string[]>([]);

addDisposableEvent(Events.addEventListener("resize", window, async () => {
    try {
        await Delay.make(1000, "windowSizeSave", true);
        let size = await OperatorApplicationPlatform.window.getSize();
        if (size) {
            if (size.maximized) {
                size.width = OperatorApplicationConfigInstance.windowSize.width;
                size.height = OperatorApplicationConfigInstance.windowSize.height;
            }
            OperatorApplicationConfigInstance.windowSize = {
                width: size.width,
                height: size.height,
                minimized: size.minimized,
                maximized: size.maximized
            };
        }

    } catch (e) {

    }
}));

let updater = OperatorApplicationPlatformFactory.updater;
if (updater) {
    try {
        updater.checkAndFetchUpdate();
    } catch (e) {

    }
}

onMounted(async () => {
    let size = OperatorApplicationConfigInstance.windowSize;
    await OperatorApplicationPlatform.window.resize(size.width, size.height, true, size.maximized);
    if (OperatorAccountStore.minimizeAfterStartup.value) {
        OperatorAccountStore.SET_MINIMIZE_AFTER_STARTUP(false);
        OperatorApplicationEventManager.once(OPERATOR_RELOAD_APP_CONFIG, () => {
            OperatorApplicationPlatform.window.minimize();
        });

    }
});

onBeforeUnmount(() => {
    /*document.documentElement.classList.add("theme-light");*/
    document.documentElement.classList.remove("dark");
});

let operatorData = OperatorAccountStore.data;

let darkThemeEnabled = computed(() => {
    let classList = document.documentElement.classList;
    let result = OperatorApplicationConfigInstance.darkThemeEnabled;
    if (result) {
        classList.add("dark");
        /*classList.remove("theme-light");*/
    } else {
        /*classList.add("theme-light");*/
        classList.remove("dark");
    }
    return result;
});

let menu = OperatorApplicationRoutingStore.menu as Ref<OperatorApplicationMenuSection[]>;

let alwaysInDomSectionIds = computed(() => {
    let result = OperatorAccountStore.data.value.buddyListConfig
        .filter(config => config.isMainBuddyList || config.isCrossOperatorsChat || config.isAnotherOperatorBuddyList)
        .map(config => OperatorApplicationRoutingStore.getDialogsSectionId(config.id));
    result.push(OPERATOR_APPLICATION_NEWS_ROUTE_NAME);
    return result;
});

function isNeedToBeInDom(item: OperatorApplicationMenuItem) {
    if (alwaysInDomSectionIds.value.indexOf(item.sectionId) > -1) {
        return true;
    }
    let result = OperatorApplicationRoutingStore.sectionId.value == item.sectionId || visitedSections.value.indexOf(item.sectionId) > -1;
    if (result) {
        if (visitedSections.value.indexOf(item.sectionId) == -1) {
            visitedSections.value.push(item.sectionId);
        }
    }
    return result;
}

let selectedSectionId = OperatorApplicationRoutingStore.sectionId;

let lightboxDownload: (url: string) => void;
if (OperatorApplicationPlatformFactory.isDownloadAvailable) {
    lightboxDownload = (url: string) => {
        OperatorApplicationPlatformFactory.download([url]);
    }
}

let applicationBadge = computed(() => {
    let result = ClientUserdataStore.unreadedApplicationBadge.value;
    OperatorApplicationPlatform.window.setBadge(result);
    return result;
});

watch(computed(() => OperatorApplicationConfigInstance.uiScale), newValue => {
    if (OperatorApplicationPlatformFactory.isNative) {
        const {webFrame} = require('electron');
        webFrame.setZoomFactor(newValue);
    }
}, {
    immediate: true
});

let showFreeDialogForFreeSiteId = OperatorAccountStore.showFreeDialogForSiteId;

function onInteraction() {
    AutoAfk.wakeUp();
}

let sitesWhereOutOfDialogsLimit = computed(() => {
    return OperatorAccountStore.data.value.sites.filter(site => {
        return OperatorAccountStore.outOfDialogsLimitSiteIds.value.includes(site.id);
    });
});


let sitesWhereUnavailableBecauseOfLicenseLimit = computed(() => {
    return OperatorAccountStore.data.value.sites.filter(site => {
        return site.isUnavailableBecauseOfLicenseLimit
    });
});

let call = computed(() => {
    let call = OperatorApplicationWebRtcCall.getCurrentCall() as OperatorApplicationWebRtcCall;
    if (call && !call.isMountedNow()) {
        return call;
    }
    return null;
})
//};

return (_ctx: any,_cache: any) => {
  return (_unref(operatorData))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass({
            'h-100 d-flex': true,
            dark: _unref(darkThemeEnabled)
        }),
        "data-application-badge": _unref(applicationBadge),
        style: _normalizeStyle({
            '--core-ui-message-reply-lines': _unref(OperatorApplicationConfigInstance).chatMessageReplyLines
        }),
        onMouseupPassive: onInteraction,
        onKeyupPassive: onInteraction
      }, [
        (_unref(OperatorAccountStore).isCabinetIframe)
          ? (_openBlock(), _createBlock(CabinetIframeWrapper, { key: 0 }, {
              default: _withCtx(() => [
                (_unref(OperatorAccountStore).cabinetClientDialog.value)
                  ? (_openBlock(), _createBlock(OperatorApplicationDialogForCabinetReports, {
                      key: 0,
                      username: _unref(OperatorAccountStore).cabinetClientDialog.value.username,
                      "dialog-id": _unref(OperatorAccountStore).cabinetClientDialog.value.dialogId
                    }, null, 8, ["username", "dialog-id"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(OperatorApplicationMainMenu),
              _createElementVNode("div", _hoisted_2, [
                (!_unref(operatorData).isWorkingNow)
                  ? (_openBlock(), _createBlock(OperatorApplicationStatusLine, {
                      key: 0,
                      class: "weekend"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(__)("Рабочее время, заданное в настройках оператора, подошло к концу")), 1)
                      ]),
                      _: 1
                    }))
                  : (_unref(sitesWhereOutOfDialogsLimit).length)
                    ? (_openBlock(), _createBlock(OperatorApplicationStatusLine, {
                        key: 1,
                        class: "out-of-dialogs-limit"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(__)("Превышен лимит активных диалогов для %s", _unref(sitesWhereOutOfDialogsLimit).map(site => site.title).join(", "))), 1),
                          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(__)("Не забудьте закрыть завершённые диалоги, чтобы стать видимым для новых клиентов")), 1)
                        ]),
                        _: 1
                      }))
                    : (_unref(sitesWhereUnavailableBecauseOfLicenseLimit).length && _unref(OperatorApplicationConfigInstance).isShowLicenseNotificationAtTop)
                      ? (_openBlock(), _createBlock(OperatorApplicationStatusLine, {
                          key: 2,
                          class: "license-limit-warning"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(__)("Превышен лимит подключенных операторов на %s", _unref(sitesWhereUnavailableBecauseOfLicenseLimit).map(site => site.title).join(", "))), 1),
                              _createElementVNode("div", null, [
                                _createVNode(FontAwesomeIcon, {
                                  class: "cursor-pointer",
                                  icon: "times",
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(OperatorApplicationConfigInstance).isShowLicenseNotificationAtTop = false))
                                })
                              ])
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu), (section) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.items.filter(item => isNeedToBeInDom(item)), (item) => {
                        return (_openBlock(), _createBlock(OperatorApplicationSection, {
                          key: item.sectionId,
                          class: _normalizeClass({
                            section: true,
                            selected: _unref(selectedSectionId) === item.sectionId
                        }),
                          "is-section-selected": _unref(selectedSectionId) === item.sectionId
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(item.component), _mergeProps({
                              "is-section-selected": _unref(selectedSectionId) === item.sectionId
                            }, { ref_for: true }, item.props), null, 16, ["is-section-selected"]))
                          ]),
                          _: 2
                        }, 1032, ["class", "is-section-selected"]))
                      }), 128))
                    ], 64))
                  }), 256))
                ])
              ])
            ], 64)),
        (_unref(call))
          ? (_openBlock(), _createBlock(WebRtcCall, {
              key: 2,
              call: _unref(call),
              style: {"display":"none"}
            }, null, 8, ["call"]))
          : _createCommentVNode("", true),
        _createVNode(NewIncomingWebRtcCall),
        (_unref(showFreeDialogForFreeSiteId))
          ? (_openBlock(), _createBlock(OperatorApplicationFreeDialog, {
              key: 3,
              "site-id": _unref(showFreeDialogForFreeSiteId)
            }, null, 8, ["site-id"]))
          : _createCommentVNode("", true),
        (_unref(lightboxSrc))
          ? (_openBlock(), _createBlock(VueEasyLightbox, {
              key: 4,
              imgs: _unref(lightboxSrc),
              download: _unref(lightboxDownload),
              visible: "",
              "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_isRef(lightboxSrc) //@ts-ignore
 ? lightboxSrc.value = null : lightboxSrc = null))
            }, null, 8, ["imgs", "download"]))
          : _createCommentVNode("", true)
      ], 46, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})